import * as Sentry from '@sentry/node';
import { rewriteFramesIntegration } from '@sentry/node';

export const init = () => {
  if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
    const integrations: any[] = [];
    const sentryServerRootDir = process.env.NEXT_PUBLIC_SENTRY_SERVER_ROOT_DIR;
    if (process.env.NEXT_IS_SERVER === 'true' && sentryServerRootDir) {
      // For Node.js, rewrite Error.stack to use relative paths, so that source
      // maps starting with ~/_next map to files in Error.stack with path
      // app:///_next
      integrations.push(
        rewriteFramesIntegration({
          iteratee: (frame) => {
            frame.filename = frame.filename?.replace(
              sentryServerRootDir,
              'app:///'
            );
            frame.filename = frame.filename?.replace('.next', '_next');
            return frame;
          },
        })
      );
    }

    Sentry.init({
      enabled: process.env.NODE_ENV === 'production',
      integrations,
      dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
      environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
      release: process.env.NEXT_PUBLIC_RELEASE_NAME,
    });
  }
};
